import React, { useState, useEffect } from 'react';

import Sidenav from './Sidenav.js'
import Header from './Header.js'
import {Sketchbook, DynamicSketchbook} from './Sketchbook.js'
import SketchbookDetail from './SketchbookDetail.js'
import Footer from './Footer.js';

import './About.css';

const About = (props) => {

	const [showScrollbar, setShowScrollbar] = useState(true);

	const [sidenavOpen, setSidenavOpen] = useState(false);
	const [sketchbookDetailOpen, setSketchbookDetailOpen] = useState(false);

	useEffect(() => {
		setShowScrollbar(!sketchbookDetailOpen);
	}, [sketchbookDetailOpen]);

	useEffect(() => {
		if (showScrollbar) {
			document.body.style.overflowY = 'auto';
		} else {
			document.body.style.overflowY = 'hidden';
		}
	}, [showScrollbar]);

	useEffect(() => {
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
	}, [])

	return (
		<div>
			<Sidenav
				setSidenavOpen={setSidenavOpen}
				isSidenavOpen={sidenavOpen && !sketchbookDetailOpen}
				setSketchbookDetailOpen={() => setSketchbookDetailOpen(true)}/>
			<SketchbookDetail
				setSketchbookDetailOpen={setSketchbookDetailOpen}
				isSketchbookDetailOpen={sketchbookDetailOpen}/>
			<Header
				hideHeader={sidenavOpen || sketchbookDetailOpen}
				setSidenavOpen={setSidenavOpen}/>
			<div className={`main-content`}>
				<Sketchbook
					title={'\
						Drawing and clay. <br/>\
						Both hold my attention. <br/>\
						Figuration in ceramic beautifully provides an elegant platform.<br/>\
						I would say this is unique.<br/>\
						An enduringly graceful position sitting perfectly between the two.\
					'}
					body={[
						<div className='qualification'>
							<div>
								<h5>Born</h5>
							</div>
							<div>
								<div className='left'>1966</div>
								<div className='right'>Midhurst, West Sussex</div>
							</div>
						</div>,
						<div className='qualification'>
							<div>
								<h5>Education</h5>
							</div>
							<div>
								<div className='left'>1996 - 97</div>
								<div className='right'>MA Ceramics, University of Wales Institute, Cardiff</div>
							</div>
							<div>
								<div className='left'>1984 - 87</div>
								<div className='right'>BA (Hons) 3D Design, Middlesex Polytechnic</div>
							</div>
						</div>,
						<div className='qualification'>
							<div>
								<h5>Awards</h5>
							</div>
							<div>
								<div className='left'>1999</div>
								<div className='right'>Setting Up Grant, The Crafts Council</div>
							</div>
						</div>,
						<div className='links'>
							<div>
								<h5>Links</h5>
							</div>
							<div className='link'>
								<a href="https://www.premiofaenza.it/works/manx-minx" target="_blank" rel="noopener noreferrer">Manx Minx</a>, 2014
								<br/>
								In the collection of Faenza Museo Internazionale, Faenza, Italy.
							</div>
							<div className='link'>
								<a href="http://www.fragmentedfigure.net/pages/j_bryers01.htm" target="_blank" rel="noopener noreferrer">Fragmented Figure</a>, 2005
								<br/>
								The Fragmented Figure Scholarly conference & Associated Exhibition was convened & curated by The Centre for Ceramic Studies, School of Art & Design, Wales. Organised by UWIC University of Wales Institute, Cardiff.
								<br/>
							</div>
						</div>,
					]}
					imgOneUrl='./res/photos/Sophie-Mutevelian-4.jpg'
					imgOneDetail={'Photo by <a href="https://www.sophiemutevelian.com" target="_blank" rel="noopener noreferrer">Sophie Mutevelian</a>'}/>
			</div>
			<div className='footer-content'>
				<Footer/>
			</div>
		</div>
	);

}

export default About;